import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Row, Spinner, Table, Button } from 'react-bootstrap';
import { Line, Pie, Bar } from 'react-chartjs-2';
import { LanguageContext } from '../Language/LanguageContext';
import "./Dashboard.css"
import { Loading, TablePagination, Container, HeaderTitle } from '../Library'
import { useHistory } from 'react-router-dom'
import axios from 'axios'
import { wtc53109 } from '../Network/Config'

function abbreviateNumber(value) {
    var newValue = value;
    if (value >= 1000) {
        var suffixes = ["", "k", "m", "b","t"];
        var suffixNum = Math.floor( (""+value).length/3 );
        var shortValue = '';
        for (var precision = 2; precision >= 1; precision--) {
            shortValue = parseFloat( (suffixNum !== 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
            var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
            if (dotLessShortValue.length <= 2) { break; }
        }
        if (shortValue % 1 !== 0)  shortValue = shortValue.toFixed(1);
        newValue = shortValue+suffixes[suffixNum];
    }
    return newValue;
}

function Dashboard(props) {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.visitor
    const [listDataBar, setListDataBar] = useState([])
    const [listDataPie, setListDataPie] = useState([])
    const [listSpare, setListSpare] = useState([])

    useEffect( async ()=>{
        const formData = new FormData();
        formData.append('company_id', props.company);
        const responseData = await axios.post(wtc53109+'/spare_part/api/v1/dashboard', formData);
        setListDataPie(responseData.data.data.chart)
        setListDataBar(responseData.data.data.data_table)
        setListSpare(responseData.data.data.list)
    }, [1000, props])

    const CountEntranceChartStat = () => {
        const [isLoadingEntranceCount, setIsLoadingEntranceCount] = useState(false)
        const [labels, setLabels] = useState([])   
        const [countData, setCountData] = useState([])     

        /*useEffect(()=>{
            const fetchCountEntranceChartStat = () => {
                setIsLoadingEntranceCount(true)
                countVisitorByMonth(
                    (data) => {
                        data.forEach((item) => {
                            setLabels((prev) => [...prev, dayjs(item.registerMonth).format("MMMM")])
                            setCountData((prev) => [...prev, item.countRegister])
                            setIsLoadingEntranceCount(false)
                        })
                    },
                    (error) => { 
                        setIsLoadingEntranceCount(false)
                    }
                )
                
            }
            fetchCountEntranceChartStat()
        },[])*/

        return(
            <div className='widget-item'>
                <div className='widget-head'>
                    <div className='widget-title'>{'รายการอัพเดทสินค้า'}</div>
                    <div>
                        { isLoadingEntranceCount ?
                        <Spinner 
                            variant='primary'
                            size='sm'
                            animation='border'/>
                        : null
                        }
                    </div>
                </div>
                <div className="table-container">
                <Table hover>
                    <thead>
                        <tr>
                            <th>{'ID'}</th>
                            <th>{'Log'}</th>
                            <th>{'Part Name'}</th>
                            <th>{'Update'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                          listSpare.slice(0, 5).map((item, key)=>
                            <TaskRow
                            key={key}
                            id={item.id}
                            log={item.log}
                            partname={item.part_name}
                            update={item.update_date}
                            />
                        )}
                    </tbody>
                </Table>
                
            </div>
            </div>
        )
    }

    const TypeChart = () => {
        const [isLoadingType, setIsLoadingType] = useState(false)
        const [registeredCount, setRegisteredCount] = useState(0)
        const [fastCount, setFastCount] = useState(0)

        /*useEffect(()=>{
            const fetchCountType = () => {
                setIsLoadingType(true)
                countVisitorByType(
                    (data) => {
                        setRegisteredCount(data.registered)
                        setFastCount(data.fast_registered)
                        setIsLoadingType(false)
                    },
                    (error) => {
                        setIsLoadingType(false)
                    })
            }
            fetchCountType()
        },[])*/

        return(
            <div className='widget-item'>
                <div className='widget-head'>
                    <div className='widget-title'>{'สัดส่วนสิ้นค้าคงเหลือ'}</div>
                    <div>
                    { isLoadingType ?
                        <Spinner 
                            variant='primary'
                            size='sm'
                            animation='border'/>
                        : null
                    }
                    </div>
                </div>
                <div style={{ height: 200 }}>
                    <Pie
                    data={{
                        labels: listDataPie.label,
                        datasets: [
                            {
                                
                                data: listDataPie.data,
                                backgroundColor:  [
                                    'rgba(54, 162, 235, 0.5)',
                                    'rgba(255, 99, 132, 0.5)',
                                ]
                            }
                        ]
                    }}
                    options={{
                        maintainAspectRatio: false
                    }}
                    />
                </div>
            </div>

        )
    }

    const BarChart = () => {
        const [isLoadingType, setIsLoadingType] = useState(false)
        const [registeredCount, setRegisteredCount] = useState(0)
        const [fastCount, setFastCount] = useState(0)

        /*useEffect(()=>{
            const fetchCountType = () => {
                setIsLoadingType(true)
                countVisitorByType(
                    (data) => {
                        setRegisteredCount(data.registered)
                        setFastCount(data.fast_registered)
                        setIsLoadingType(false)
                    },
                    (error) => {
                        setIsLoadingType(false)
                    })
            }
            fetchCountType()
        },[])*/
        
        return(
            <div className='widget-item'>
                <div className='widget-head'>
                    <div className='widget-title'>{'สถิติการเปลี่ยนตามประเภท'}</div>
                    <div>
                    { isLoadingType ?
                        <Spinner 
                            variant='primary'
                            size='sm'
                            animation='border'/>
                        : null
                    }
                    </div>
                </div>
                <div style={{ height: 200 }}>
                    <Bar
                    type='bar'
                    data={{
                        labels: ['ไฟฟ้า', 'ประปา'],
                        datasets: listDataBar
                    }}
                    options={{
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [{
                                display: true,
                                ticks: {
                                    suggestedMin: 0,
                                    beginAtZero: true
                                }
                            }]
                        }
                    }}
                    />
                </div>
            </div>

        )
    }

    return(
        <div id="visitor-dashboard">
            <Row>
                <Col md={6}>
                    <BarChart/>
                </Col>
                <Col md={6}>
                    <TypeChart/>
                </Col>
                <Col xs={12}>
                    <CountEntranceChartStat/>
                </Col>
            </Row>
        </div>
    )
}


function TaskRow(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.repair_service
    const history = useHistory()

    const convertDate = (date) =>{
        let toDate = new Date(date)
        let formattedDate = dayjs(toDate).format("D MMM YYYY H:mm")
        return formattedDate
    }

    return(
        <tr>
            <td>{props.id}</td>
            <td>{props.log}</td>
            <td>{props.partname}</td>
            <td>{props.update}</td>
        </tr>
    )
}

export default Dashboard;
